import React from 'react';
import './AboutUs.css';

import { PageTitle } from '../../../components';
import { About, Testimonials, Counter, Team, Services, Process, Banner, Clients, Awards, WhyUs, Mission, FAQs, Industries } from '../../../sections';
import { faqsContent } from '../../../constants';



const AboutUs = () => {

  return (
    <>

      {/* Page title */}
      <PageTitle title={'about us'} page={'about us'} />

      <section className='about-us'>

        <About />
        <Counter />
        <Services />
        <WhyUs />
        <Process />
        <Mission />
        <FAQs faqsContent={faqsContent} /> {/* FAQs Section */}
        <Industries />
        <Team />
        <Testimonials />
        <Awards />
        <Banner />
        <Clients />

      </section>

    </>
  );
}

export default AboutUs;